'use strict';

const $ = require('jquery');

class Popup {

    constructor() {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        $('[data-popup="video"]').magnificPopup({
            disableOn: 600,
            type: 'iframe',
            closeMarkup: '<span title="%title%" class="mfp-close">&#215;</span>'
        });

    }

}

module.exports = Popup;
